import { IMPERSONATE_KEY } from 'hooks/use-impersonation';

import { LAST_ACTIVITY_KEY } from 'constants/session';

export const OKTA_KEY = 'okta-token-storage';
const REFFERER_PATH = 'secureRouterReferrerPath';

interface OktaTokenStorage {
  accessToken?: { accessToken?: string };
  idToken?: { claims?: { sub?: string } };
}

interface ImpersonatingUserInfo {
  oktaUserId?: string;
}

const getOktaSessionInfo = (): OktaTokenStorage | null => {
  const raw = window.localStorage.getItem(OKTA_KEY);

  if (!raw) return null;

  try {
    return JSON.parse(raw) as OktaTokenStorage;
  } catch {
    return null;
  }
};

export const clearOktaSessionInfo = (): void => {
  window.localStorage.removeItem(OKTA_KEY);
  window.localStorage.removeItem(IMPERSONATE_KEY);
  window.localStorage.removeItem(REFFERER_PATH);
  window.localStorage.removeItem(LAST_ACTIVITY_KEY);
};

export const getOktaBearerToken = (): string | null => {
  const oktaStorage = getOktaSessionInfo();
  let token: string | null = null;

  if (oktaStorage && oktaStorage.accessToken) {
    token = oktaStorage.accessToken.accessToken ?? null;
  }

  return token;
};

export const getOktaUserId = (): string | null => {
  const impersonatingRaw = window.localStorage.getItem(IMPERSONATE_KEY);
  const impersonatingUserInfo = impersonatingRaw
    ? (JSON.parse(impersonatingRaw) as ImpersonatingUserInfo)
    : null;

  if (impersonatingUserInfo) return impersonatingUserInfo.oktaUserId ?? null;

  const oktaStorage = getOktaSessionInfo();

  if (oktaStorage && oktaStorage.idToken) {
    return oktaStorage.idToken.claims?.sub ?? null;
  }

  return null;
};
